/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../../teller/teller';
import '../common/common';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "esperanto": {
        "nested": {
          "api": {
            "nested": {
              "FinalizeBankTransactionRequest": {
                "fields": {
                  "paymentId": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "desiredStatus": {
                    "type": ".squareup.esperanto.api.FinalizeBankTransactionRequest.DesiredStatus",
                    "id": 2,
                    "rule": "optional"
                  },
                  "failureReason": {
                    "type": ".squareup.teller.FailureReason",
                    "id": 3,
                    "rule": "optional"
                  },
                  "internalFailureReason": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "returnReason": {
                    "type": ".squareup.teller.ReturnReason",
                    "id": 6,
                    "rule": "optional"
                  },
                  "failureMessage": {
                    "type": "string",
                    "id": 7,
                    "rule": "optional"
                  },
                  "returnFileToken": {
                    "type": "string",
                    "id": 8,
                    "rule": "optional"
                  },
                  "options": {
                    "type": ".squareup.esperanto.common.ReverseOptions",
                    "id": 5,
                    "rule": "optional"
                  },
                  "processingSpeed": {
                    "type": ".squareup.esperanto.api.FinalizeBankTransactionRequest.ProcessingSpeed",
                    "id": 9,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "DesiredStatus": {
                    "values": {
                      "DO_NOT_USE": 0,
                      "COMPLETED": 1,
                      "FAILED": 2
                    }
                  },
                  "ProcessingSpeed": {
                    "values": {
                      "DEFAULT_DO_NOT_USE_PROCESSING_SPEED": 0,
                      "NORMAL": 1,
                      "ACCELERATED": 2
                    }
                  }
                }
              },
              "FinalizeBankTransactionResponse": {
                "fields": {
                  "paymentId": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "status": {
                    "type": ".squareup.esperanto.common.OperationStatus",
                    "id": 3,
                    "rule": "optional"
                  },
                  "errors": {
                    "type": ".squareup.esperanto.api.FinalizeBankTransactionError",
                    "id": 1,
                    "rule": "repeated"
                  }
                }
              },
              "FinalizeBankTransactionError": {
                "values": {
                  "DEFAULT_DO_NOT_USE": 0,
                  "INVALID_STATE": 1,
                  "BAD_REQUEST": 2,
                  "RECORD_NOT_FOUND": 3
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.esperanto?.nested?.api?.nested?.FinalizeBankTransactionRequest && !$root.nested?.squareup?.nested?.esperanto?.nested?.api?.nested?.FinalizeBankTransactionRequest?.nested?.DesiredStatus && !$root.nested?.squareup?.nested?.esperanto?.nested?.api?.nested?.FinalizeBankTransactionRequest?.nested?.ProcessingSpeed && !$root.nested?.squareup?.nested?.esperanto?.nested?.api?.nested?.FinalizeBankTransactionResponse && !$root.nested?.squareup?.nested?.esperanto?.nested?.api?.nested?.FinalizeBankTransactionError) {
  $root.addJSON(jsonData);
}

/**
 * Request payload for finalizing a bank transaction.
 *
 * SOURCE FinalizeBankTransactionRequest @ squareup/esperanto/api/finalize_bank_transaction.proto at 14:1
 */
export const FinalizeBankTransactionRequest = $root.lookupType('squareup.esperanto.api.FinalizeBankTransactionRequest');
fixType(FinalizeBankTransactionRequest, {
  paymentId: {
    required: true
  },
  desiredStatus: {
    required: true
  }
});
Builder.createAndAttachToType(FinalizeBankTransactionRequest);
/**
 * SOURCE DesiredStatus @ squareup/esperanto/api/finalize_bank_transaction.proto at 18:3
 */
FinalizeBankTransactionRequest.DesiredStatus = $root.lookupEnum('squareup.esperanto.api.FinalizeBankTransactionRequest.DesiredStatus').values;
/**
 * Processing speed used for finalizing bank transfer.
 *
 * SOURCE ProcessingSpeed @ squareup/esperanto/api/finalize_bank_transaction.proto at 52:3
 */
FinalizeBankTransactionRequest.ProcessingSpeed = $root.lookupEnum('squareup.esperanto.api.FinalizeBankTransactionRequest.ProcessingSpeed').values;
/**
 * Response payload for finalizing a bank transaction.
 *
 * SOURCE FinalizeBankTransactionResponse @ squareup/esperanto/api/finalize_bank_transaction.proto at 68:1
 */
export const FinalizeBankTransactionResponse = $root.lookupType('squareup.esperanto.api.FinalizeBankTransactionResponse');
fixType(FinalizeBankTransactionResponse);
Builder.createAndAttachToType(FinalizeBankTransactionResponse);
/**
 * SOURCE FinalizeBankTransactionError @ squareup/esperanto/api/finalize_bank_transaction.proto at 81:1
 */
export const FinalizeBankTransactionError = $root.lookupEnum('squareup.esperanto.api.FinalizeBankTransactionError').values;